// extracted by mini-css-extract-plugin
export default {"avatarMenu":"style_avatarMenu__w7aW5"};